import { css } from 'styled-components';

export const withRetinaBackground = (imgPath: string, retinaImgPath: string) => {
	return css`
		background-image: url(${imgPath});

		@media (-webkit-min-device-pixel-ratio: 2), (min-resolution: 192dpi) {
			background-image: url(${retinaImgPath});
		}
	`;
};
